import searchLogo from "../assets/images/searchLogo.svg";
import { dateFormatter } from "../components/AgGrid/grid-util";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";
import { dateFormat } from "./commonFunctions";
import { dtcStatusColors } from "./constants";

export const columnSecMaster = [
    {
        headerName: "Ticker",
        field: "ticker",
        floatingFilter: false,
        icons: {
          menu: `<img src="${searchLogo}" />`,
        },
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellStyle: (params: any) => {
          if (params?.node?.data?.isRowUpdated && params?.node?.data?.isTickerUpdated) {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1',
              backgroundColor: dtcStatusColors.pended
            }
          } else {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1'
            }
          }
        },
        minWidth: 100,
        maxWidth: 130,
        suppressSizeToFit: false,
        cellRenderer: TickerHyperLinkComponent,
        editable: function (params: any) {
          if (params.node.data.isNewRowInsert) {
            return true
          } else {
            return false
          }
        }
      },
      {
        headerName: "Cusip",
        field: "cusip",
        floatingFilter: false,
        icons: {
          menu: `<img src="${searchLogo}" />`,
        },
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellStyle: (params: any) => {
          if (params?.node?.data?.isRowUpdated && params?.node?.data?.isCusipUpdated) {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1',
              backgroundColor: dtcStatusColors.pended
            }
          } else {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1'
            }
          }
        },
        minWidth: 100,
        maxWidth: 180,
        suppressSizeToFit: false,
        filterParams: {
          allowedCharPattern: '\\d\\-\\,',
          numberParser: (text: any) => {
            return parseFloat(text.replace(',', ''))
          }
        },
        editable: function (params: any) {
          if (params.node.data.isNewRowInsert) {
            return true
          } else {
            return false
          }
        }
      },
      {
        headerName: "Price",
        field: "price",
        floatingFilter: false,
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellStyle: (params: any) => {
          if (params?.node?.data?.isRowUpdated && params?.node?.data?.isPriceUpdated) {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1',
              backgroundColor: dtcStatusColors.pended,
              justifyContent: 'flex-end'
            }
          } else {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1',
              justifyContent: 'flex-end'
            }
          }
        },
        minWidth: 120,
        maxWidth: 150,
        icons: {
          menu: `<img src="${searchLogo}" />`,
        },
        editable: true
      },
      {
        headerName: "Name",
        field: "name",
        floatingFilter: false,
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellStyle: (params: any) => {
          if (params?.node?.data?.isRowUpdated && params?.node?.data?.isNameUpdated) {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1',
              backgroundColor: dtcStatusColors.pended
            }
          } else {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1'
            }
          }
        },
        minWidth: 200,
        maxWidth: 250,
        icons: {
          menu: `<img src="${searchLogo}" />`,
        },
        editable: true
      },
      {
        headerName: "Date",
        field: "date",
        floatingFilter: false,
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellStyle: (params: any) => {
          if (params?.node?.data?.isRowUpdated && params?.node?.data?.isDateUpdated) {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1',
              backgroundColor: dtcStatusColors.pended
            }
          } else {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1'
            }
          }
        },
        minWidth: 130,
        maxWidth: 150,
        valueFormatter: dateFormat,
        filterParams: {
          valueFormatter: dateFormat,
        },
        suppressSizeToFit: false,
        icons: {
          menu: `<img src="${searchLogo}" />`,
        },
        editable: false
      },
      {
        headerName: "Sm Id",
        field: "sm_id",
        floatingFilter: false,
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellStyle: (params: any) => {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1'
          }
        },
        minWidth: 130,
        maxWidth: 150,
        suppressSizeToFit: false,
        icons: {
          menu: `<img src="${searchLogo}" />`,
        },
        editable: false
      },
      {
        headerName: "Cins",
        field: "cins",
        floatingFilter: false,
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellStyle: {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        },
        minWidth: 130,
        maxWidth: 150,
        suppressSizeToFit: false,
        icons: {
          menu: `<img src="${searchLogo}" />`,
        },
      },
      {
        headerName: "Isin",
        field: "isin",
        floatingFilter: false,
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellStyle: (params: any) => {
          if (params?.node?.data?.isRowUpdated && params?.node?.data?.isIsInUpdated) {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1',
              backgroundColor: dtcStatusColors.pended
            }
          } else {
            return {
              display: 'flex',
              alignItems: 'center',
              borderRight: '0.5px solid #E1E1E1'
            }
          }
        },
        minWidth: 130,
        maxWidth: 150,
        suppressSizeToFit: false,
        icons: {
          menu: `<img src="${searchLogo}" />`,
        },
        editable: true
      },
      {
        headerName: "Is Override",
        field: "isOverride",
        floatingFilter: false,
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellStyle: {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        },
        minWidth: 100,
        maxWidth: 130,
        suppressSizeToFit: false,
        icons: {
          menu: `<img src="${searchLogo}" />`,
        },
      },
      {
        headerName: "Updated Time",
        field: "updatedTime",
        valueFormatter: dateFormatter,
        floatingFilter: false,
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellStyle: {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        },
        minWidth: 250,
        maxWidth: 250,
        suppressSizeToFit: false,
        icons: {
          menu: `<img src="${searchLogo}" />`,
        },
      },
]